<template>
  <header class="header" id="Header">
    <div class="header-left">开庭案件：{{ title }}</div>
    <div class="header-right">
      <p class="user_name">通话时长：</p>
            <p class="user_name">00：30：22</p>
      <el-avatar icon="el-icon-microphone"></el-avatar>
      <el-button class="index_exit_btn" type="primary" round @click="logout">退出</el-button>
    </div>
  </header>
</template>

<script>
  export default {
    data() {
      return {
      };
    },
    props:{
      title:{
        type:String,
        default:''
      }
    },
    watch:{
      // text:{
      //   handler(newVal,oldVal) {
      //     console.log(newVal,'new')
      //     console.log(oldVal,'old')
      //   },
      //   deep: true
      // }
    },
    created() {
    },
    methods: {
      // 系统登出
      logout(){
        this.$emit('logout');
        // this.$router.push('/')
      }
    }
  };
</script>

<style lang="scss">
@import '../theme/variables';
#Header {
  height: 60px;
  background: map-get($colors, primary);
  display: flex;
  align-items: center;
  padding: 0 30px;
  line-height: 80px;
  justify-content: space-between;
  color: #ffffff;
  .header-left {
    font-size: 20px;
  }
  .header-right {
    justify-content: flex-end;
    display: flex;
    height: 60px;
    align-items: center;
  }
  .index_exit_btn {
    width: 98px;
    height: 36px;
    border: 0;
    font-size: 20px;
    background: map-get($colors, primary-shade);
    text-align: center;
    margin-left: 60px;
  }
  .index_line {
    height: 31px;
    border-right: 1px solid white;
    margin: 0 60px;
  }
  .user_name {
    height: 80px;
    line-height: 80px;
    font-size: 18px;
  }
  .el-avatar--icon {
    font-size: 22px;
  }
  .el-avatar {
    background: map-get($colors, primary);
  }
}
</style>
